import React, { useEffect, useState } from 'react'
import AppDataGrid from "../../../../components/datatable/AppDataGrid";
import { flowDetailColumns } from '../component/tablecolumn/flowdetailColumn';
import CreateFlow from './createFlow';
import PopUpEditflowdetail from './component/popUpEditflowdetail';
// import FetchApi from '../../../customhooks/Functionapi';
// import { Link } from "react-router-dom";
import { Button } from '@mui/material';
import { GridActions, ActionTextButton, ActionPopup } from '../../../../components/datatable/GridActions';

function Flowdetaillist({ dataresult, isRemove }) {

    const [data, setData] = useState(dataresult)

    const handleDelete = (id) => {
        // isRemove
        isRemove(id)
        // setData(data.filter((item) => item.flowdetailId !== id));
    }

    const getRowId = (row) => {
        return row.flowdetailId;
    }

    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 300,
            renderCell: (params) => {
                return (
                    <GridActions>
                        {/* <Link to={`/admin/Flow/flowdetail/${params.row.flowdetailId}`} style={{ textDecoration: "none" }}>
                      <div className="viewButton">จัดการผู้อนุมัติ</div>
                    </Link> */}
                        <ActionPopup tone="add">
                            <CreateFlow
                                detailId={params.row.flowdetailId}
                                flowStatus={params.row.typename}
                                flowstate={params.row.stateflow}
                                department={params.row.departmentname}
                                departcode={params.row.departmentType}
                            />
                        </ActionPopup>
                        <ActionPopup tone="edit"><PopUpEditflowdetail Id={params.row.flowdetailId} /></ActionPopup>
                        <ActionTextButton tone="delete" onClick={() => handleDelete(params.row.flowdetailId)}>Delete</ActionTextButton>
                    </GridActions>
                );
            },
        },
    ];

    return (
        <AppDataGrid
            className="datagrid"
            getRowId={getRowId}
            rows={dataresult}
            columns={flowDetailColumns.concat(actionColumn)}
            // columns={userColumns}
            initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
            pageSizeOptions={[10, 25, 50, 100]}
        //    checkboxSelection
        />
    )
}

export default Flowdetaillist